import React from "react";
import SideMenu from "@/common/UI/Navigation/SideMenu";
import appText from "@/lang/appText";

const sections = {
  Home: {
    label: appText.objects.dashboard.singular,
    path: "/admin/dashboard",
    icon: "home",
  },
  Applications: {
    label: appText.objects.application.plural,
    path: "/admin/applications",
    icon: "copy outline",
  },
  Jobs: {
    label: appText.objects.job.plural,
    path: "/admin/jobs",
    icon: "briefcase",
  },
  Candidates: {
    label: appText.objects.candidate.plural,
    path: "/admin/candidates",
    icon: "users",
  },
  Registration: {
    label: appText.objects.registration.plural,
    path: "/admin/registration",
    icon: "mail",
    permissions: [{ action: "CREATE", object: "JOB" }],
  },
  Users: {
    label: appText.objects.user.plural,
    path: "/admin/users",
    icon: "user",
    permissions: [{ action: "READ", object: "USER" }],
  },
  Branches: {
    label: appText.objects.branch.plural,
    path: "/admin/branches",
    icon: "sitemap",
    permissions: [
      { action: "READ", object: "BRANCH" },
      { action: "CREATE", object: "BRANCH" },
      { action: "UPDATE", object: "BRANCH" },
    ],
  },
  Roles: {
    label: appText.objects.role.plural,
    path: "/admin/roles",
    icon: "shield",
    permissions: [{ action: "READ", object: "ROLE" }],
  },
};

const AdminSideMenu = ({ open, onNavigate }) => {
  return (
    <SideMenu
      open={open}
      onNavigate={onNavigate}
      options={Object.keys(sections).map(
        (sectionName) => sections[sectionName]
      )}
    />
  );
};

export default AdminSideMenu;
